export const REACT_APP_MATRIX_SERVER_URL = process.env.REACT_APP_MATRIX_SERVER_URL;
export const REACT_APP_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
export const SCOPE = encodeURIComponent('offline_access openid profile');
export const REACT_APP_REALM_NAME = process.env.REACT_APP_REALM_NAME;
export const LOGIN_URL = `${REACT_APP_MATRIX_SERVER_URL}/_matrix/client/v3/login/sso/redirect/oidc-${REACT_APP_REALM_NAME}?redirectUrl=${REACT_APP_REDIRECT_URI}&org.matrix.msc3824.action=login&scope=${SCOPE}`;
export const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const REACT_APP_ENDPOINT_URL = process.env.REACT_APP_ENDPOINT_URL;
export const LOGOUT_URL = `${REACT_APP_ENDPOINT_URL}/logout?post_logout_redirect_uri=${REACT_APP_REDIRECT_URI}&client_id=${REACT_APP_CLIENT_ID}`;
export const REACT_APP_CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const REACT_APP_IAM_BASE_URL = process.env.REACT_APP_IAM_BASE_URL;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_HASURA_ADMIN_SECRET = process.env.REACT_APP_HASURA_ADMIN_SECRET;
export const S3_URL = process.env.REACT_APP_S3_URL!;
export const S3_ACCESS_KEY = process.env.REACT_APP_S3_ACCESS_KEY!;
export const S3_SECRET = process.env.REACT_APP_S3_SECRET!;
export const REACT_APP_ENGINE_BASE_URL = process.env.REACT_APP_ENGINE_BASE_URL;
export const REACT_APP_STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
